<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-20">
    <div class="bg-white rounded-lg p-8 xl:w-2/5 w-3/5 ">
        <div
            *ngIf="anamneseChoosePopupType['has_previous_anamnese'] && !anamneseChoosePopupType['has_unanswered_anamnese']">
            <div class="flex justify-between items-center mb-6">
                <h1 class="font-bold text-2xl">Enviar Anamnese</h1>
                <div (click)="openClose()"><fa-icon [icon]="faTimes" [ngClass]="{
                    'cursor-pointer hover:text-neutral-900': !loading,
                    'cursor-default text-neutral-400': loading
                }"></fa-icon></div>
            </div>
            <p class="text-sm text-black">Deseja reutilizar os dados da Anamnese anterior?</p>
            <div class="flex justify-between mt-8">
                <div class="flex gap-2">
                    <div (click)="onConfirmAnamneseChoosePopup(true)" [ngClass]="{
                        'cursor-default text-neutral-400 bg-westetics-blue': loading,
                        'cursor-pointer text-white hover:bg-westetics-blue-dark bg-westetics-blue': !loading
                     }" class="font-medium rounded-md px-3 py-2">
                        Reutilizar</div>
                    <div (click)="onConfirmAnamneseChoosePopup(false)" [ngClass]="{
                        'cursor-default text-neutral-400 bg-westetics-blue': loading,
                        'cursor-pointer text-white hover:bg-westetics-blue-dark bg-westetics-blue': !loading
                     }" class="font-medium rounded-md px-3 py-2">
                        Nova Anamnese</div>
                </div>
                <div (click)="openClose()" [ngClass]="{
                   'cursor-default text-neutral-400': loading,
                   'cursor-pointer text-black hover:bg-neutral-200': !loading
                }" class="bg-neutral font-medium rounded-md px-3 py-2 ml-4">Cancelar</div>
            </div>
        </div>
        <div *ngIf="anamneseChoosePopupType['has_unanswered_anamnese']">
            <div class="flex justify-between items-center mb-6">
                <h1 class="font-bold text-2xl">Anamnese em andamento</h1>
                <div (click)="openClose()"><fa-icon [icon]="faTimes" [ngClass]="{
                    'cursor-pointer hover:text-neutral-900': !loading,
                    'cursor-default text-neutral-400': loading
                }"></fa-icon></div>
            </div>
            <p class="text-sm text-black">Existe uma anamnese já em andamento!</p>
            <p class="text-sm text-black">O que deseja fazer com ela?</p>

            <div class="flex justify-between mt-8">
                <div class="flex gap-2">
                    <div (click)="onClickReopenAnamneseOngoingChoosePopup()" [ngClass]="{
                        'cursor-default text-neutral-400 bg-westetics-blue': loading,
                        'cursor-pointer text-white hover:bg-westetics-blue-dark bg-westetics-blue': !loading
                     }" class="font-medium rounded-md px-3 py-2">
                        Acessar</div>
                    <div (click)="onClickDeleteAnamneseOngoingChoosePopup()" [ngClass]="{
                        'cursor-default text-neutral-400 bg-westetics-blue': loading,
                        'cursor-pointer text-white hover:bg-westetics-blue-dark bg-westetics-blue': !loading
                     }" class="font-medium rounded-md px-3 py-2">
                        Excluir e gerar uma nova</div>
                </div>
                <div (click)="openClose()" [ngClass]="{
                   'cursor-default text-neutral-400': loading,
                   'cursor-pointer text-black hover:bg-neutral-200': !loading
                }" class="bg-neutral font-medium rounded-md px-3 py-2 ml-4">Cancelar</div>
            </div>
        </div>
    </div>
</div>